import { render, staticRenderFns } from "./RenderClassTestPerfom.vue?vue&type=template&id=24dc1c48&scoped=true"
import script from "./RenderClassTestPerfom.vue?vue&type=script&lang=js"
export * from "./RenderClassTestPerfom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc1c48",
  null
  
)

export default component.exports